// Open external links in a new window.
export const LinkOpener = () => {
  const allLinks = document.querySelectorAll("a");

  if (allLinks.length) {
    for (const link of allLinks) {
      if (link.hostname != location.hostname) {
        link.rel = "noopener";
        link.target = "_blank";
      }
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  LinkOpener();
});
